import CategoryHeader from '@/components/molecules/CategoryHeader'
import PartRow from '@/components/molecules/PartRow'
import { useScopedI18n } from '@/locales/client'
import type { Category } from '@/services/schemas'
import { sortAscByOrder } from '@/util/sortOrder'

type CategorySectionProps = {
  category: Category
}

function CategorySection({ category }: CategorySectionProps) {
  const t = useScopedI18n('categorySubheadlines')

  return (
    <section className="relative flex flex-col gap-[2px]">
      <CategoryHeader
        categoryId={category.id}
        subtitle={category.id === '4' && t('powerCenter')}
      >
        {category.categoryname}
      </CategoryHeader>

      {category.parts
        .sort(sortAscByOrder)
        .map(part => (
          <PartRow
            key={part.id}
            part={part}
            categoryId={category.id}
          />
        ))}
    </section>
  )
}

export default CategorySection
